/**
 * 워커 상태 목록의 조회 축. URL 이 소유한다(rules.md §17). 그래서 새로고침·딥링크 후에도 유지된다.
 * 목록은 페이지네이션 없는 단일 GET 이다. 그래서 클라이언트에서 거른다(`WorkerStatusTableSource`).
 */
export type WorkerFilterState = {
  // 기본은 online 워커만 표시한다. 끄면 보존 윈도우(12h) 안에 보고한 모든 워커를 표시한다.
  liveOnly: boolean;
};

export const EMPTY_WORKER_FILTERS: WorkerFilterState = { liveOnly: false };

const PARAM = { live: "live" } as const;
const LIVE_OFF = "0";

export function readWorkerFilters(params: URLSearchParams): WorkerFilterState {
  return { liveOnly: params.get(PARAM.live) !== LIVE_OFF };
}

// 자기 키만 지우고 다시 쓴다. 입력은 변경하지 않는다.
export function writeWorkerFilters(
  params: URLSearchParams,
  state: WorkerFilterState,
): URLSearchParams {
  const next = new URLSearchParams(params);
  if (state.liveOnly) {
    next.delete(PARAM.live);
  } else {
    next.set(PARAM.live, LIVE_OFF);
  }
  return next;
}
